export default __webpack_public_path__ + "static/media/workfields004.06a979a2.jpg";